import * as React from 'react'
import { Link } from 'react-router-dom'
import { Dropdown, Nav, Navbar } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { IAppNavbarProps, INavbarUser } from './types'
import { buildLogo, dropdownForLangs } from './helpers'

export const NavbarUser: React.FC<INavbarUser> = ({ user }: INavbarUser) => {
    const { name, login, onSignOut, items, userLogo } = user

    const dropdownItems = items.map((item, key) => (
        <Link
            key={key}
            className="dropdown-item"
            to={item.link}
            onClick={item.handleClick}
        >
            {item.text}
        </Link>
    ))

    return (
        <div className="navbar-user d-flex mr-2 ml-4 text-light align-items-center">
            <Dropdown className="mr-3 cursor_pointer">
                <Dropdown.Toggle
                    as="div"
                    id="dropdown-basic"
                    className="d-flex"
                >
                    <div>
                        <div className="text-light">{name}</div>
                        <div className="text-muted">{login}</div>
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {dropdownItems}
                    <Dropdown.Divider />
                    <Link
                        className="btn-sign-out dropdown-item"
                        to="/login"
                        onClick={onSignOut}
                    >
                        Sign out
                    </Link>
                </Dropdown.Menu>
            </Dropdown>
            <img
                height={36}
                width={36}
                src={userLogo}
                alt="user logo"
            />
        </div>
    )
}

export const AppNavbar: React.FC<IAppNavbarProps> = ({
    i18nLangs,
    exitButton,
    currentLangKey,
    onLangChange,
    navbarItemsRight,
    isAuthenticated,
    onSidebarHandlerClick,
    user,
    logo,
}: IAppNavbarProps) => {
    const buildToggleButton = (callback: any) => {
        const handleClick = () => callback()
        return (
            <div
                className="d-flex navbar-border navbar-content-align"
                onClick={handleClick}
            >
                <FontAwesomeIcon
                    icon={faBars}
                    size={'2x'}
                    className="text-white"
                />
            </div>
        )
    }

    return (
        <Navbar
            bg="dark"
            variant="dark"
            expand="md"
            className="app-navbar"
        >
            {isAuthenticated ? buildToggleButton(onSidebarHandlerClick) : null}
            <div className="navbar-border">{buildLogo(logo)}</div>
            <Nav className="ml-auto align-items-baseline">
                {isAuthenticated && navbarItemsRight
                    ? navbarItemsRight.map((item) => item)
                    : null}
                {isAuthenticated && user ? <NavbarUser user={user} /> : null}
                {dropdownForLangs(i18nLangs, currentLangKey, onLangChange)}
                {isAuthenticated && exitButton ? exitButton : null}
            </Nav>
        </Navbar>
    )
}
